import { AMPLIFY_KEYS } from './accounts';

export const deleteLocalStorageAuth = () => {
  Object.values(AMPLIFY_KEYS).forEach((key) => localStorage.removeItem(key));
};

/**
 * Storage throws in private browsing and on a full quota, so reads fall back to off and writes
 * are best-effort — a remembered preference is never worth breaking a page for.
 */
export const readBooleanPref = (key: string): boolean => {
  try {
    return localStorage.getItem(key) === 'true';
  } catch {
    return false;
  }
};

export const writeBooleanPref = (key: string, value: boolean): void => {
  try {
    localStorage.setItem(key, String(value));
  } catch (e) {
    console.error('Error accessing localStorage:', e);
  }
};
